<template>
  <div>
    <CapaForm
      :show="showCapaForm"
      :familias="familias"
      :initialEditModel="capa"
      :form_title="form_title"
      @save="handleSave"
      @cancel="handleCancel"
      ref="capaFormRef"
    />
    <GenericDataTable
      v-if="validPermission('O0006')"
      ref="dataTableRef"
      @row-click="null"
      @boolean-toggle="handleBooleanToggle"
      @action="handleTableAction"
      :tableData="capaData"
      :api-url="null"
      :useServerSide="false"
      :columns="capaColumns"
      :show_close_btn="false"
      table_title="Capas"
    >
      <template #left-actions>
        <button
          class="action-btn filter-btn"
          @click="showFilter = !showFilter"
          title="Filtros"
        >
          <i class="fa-solid fa-filter"></i>
        </button>
        <button
          class="action-btn filter-btn"
          @click="triggerAction({ action: 'create_capa' })"
          title="Adicionar"
        >
          <i class="fa-solid fa-circle-plus fa-xl"></i>
        </button>
      </template>
    </GenericDataTable>
    <div
    v-if="showImageModal"
    class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
    @click.self="closeImageModal"
  >
    <div class="bg-[var(--fundoApp)] rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-auto">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-[var(--titulo)] text-lg font-semibold">Visualizar Imagem</h3>
        <button
          @click="closeImageModal"
          class="text-[var(--label)] hover:text-[var(--titulo)]"
        >
          <i class="fa-solid fa-times text-2xl"></i>
        </button>
      </div>

      <!-- Image Viewer -->
      <div class="flex justify-center items-center">
        <img
          v-if="imageUrl"
          :src="imageUrl"
          alt="Visualização da Imagem"
          class="max-w-full max-h-[70vh] object-contain rounded"
          @error="handleImageError"
        />
        <div v-else class="flex items-center justify-center h-[70vh]">
          <i class="fa-solid fa-spinner fa-spin text-4xl text-[var(--label)]"></i>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import { toast } from "vue3-toastify";
import axios from "axios";
import permissionMixin from "@/permissionMixin.js";
import CapaForm from "@/components/capa_template/capa/capaForm.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
export default {
  mixins: [permissionMixin],
  name: "app-capa",
  components: {
    CapaForm,
    GenericDataTable,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      capaData: [],
      familias: [],
      editId: null, // If editing, set the id here
      showCapaForm: false,
      capa: {},
      form_title: "",
      capaColumns: [
        {
          key: "familia.nome",
          label: "Família",
          sortable: true,
          type: "string",
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: true,
          type: "string",
        },
        {
          key: "created_at",
          label: "Data Criação",
          sortable: false,
          type: "datetime",
        },
        {
          key: "status",
          label: "Estado",
          sortable: true,
          type: "badge",
        },

        {
          key: "",
          label: "Ações",
          sortable: false,
          type: "actions",
          actions: [
            // Edit
            {
              type: "edit",
              icon: "fa-solid fa-pen-to-square",
              class:
                "action-icon-btn text-blue-500 bg-blue-100/20 hover:bg-blue-100",
              title: "Editar Capa",
            },
            {
                type: "delete",
                icon: "fa-solid fa-trash",
                class:
                  "action-icon-btn text-red-500 bg-red-100/20 hover:bg-red-100",
                title: "Eliminar Capa",
                
            },
            // View file
            {
              type: "viewFile",
              icon: "fa-solid fa-image",
              class:
                "action-icon-btn text-red-500 bg-red-100/20 hover:bg-red-100",
              title: "Ver Capa",
              showIf: (item) => {
                return !!item.capa_path;
              },
            },
          ],
        },
      ],
      showImageModal: false,
      imageUrl: null,
    };
  },
  methods: {
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error creating data:", error);
        this.lastError = error.response?.data || error;
        return null;
      }
    },
    async update(data, url) {
      try {
        const res = await axios.put(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error updating data:", error);
        this.lastError = error.response?.data || error;
        return null;
      }
    },
    async fetchCapaData() {
        try {
            const res = await this.select(`${this.baseURL}/api/v1/capa/`);
            this.capaData = res;
            console.log("Fetched capa data:", this.capaData);
        } catch (error) {
            console.error("Error fetching capa data:", error);
        }
    },


    handleTableAction({ type, item }) {
      console.log("Table action:", type, item);
      if (type === "edit") {
        this.select_capa(item);
        this.form_title = "Editar Entrada";
      } else if (type === "viewFile") {
        this.viewFile(item);
      } else if (type === "delete") {
       this.handleDelete(item);
      }
      // if (action === "edit") {
      //   this.select_capa(row);
      // } else if (action === "viewArtigos") {
      //   // Handle view articles action
      //   this.$router.push({ name: 'EntradaArtigos', params: { entradaId: row.id } });
      // }
    },
   
    triggerAction(action) {
      if (action.action === "create_capa") {
        this.showCapaForm = true;
        this.capa = {};
        this.form_title = "Criar Capa";
        window.scrollTo({ top: 0, behavior: "smooth" });    
      }
    },
    select_capa(row) {
      this.select(`${this.baseURL}/api/v1/capa/${row.id}/`).then(
        (data) => {
          this.capa = data;
          this.showCapaForm = true;
          this.form_title = "Editar Capa";
          this.editId = row.id;
          window.scrollTo({ top: 0, behavior: "smooth" });
        },
      );
    },
    async handleSave(formModel) {
      const file = formModel.file;
      const dataToSave = { ...formModel };
      delete dataToSave.file; // Remove file from payload before sending to API

      if (this.editId) {
        // Update
        const url = `${this.baseURL}/api/v1/capa/${this.editId}/`;
        const result = await this.update(dataToSave, url);
        if (result) {
          // Upload file if one was selected
          if (file) {
            await this.uploadFile(file, this.editId);
          }
          
          toast("Capa atualizada com sucesso!", {
            type: "success",
          });
          this.showCapaForm = false; // Close form after update
          this.editId = null; // Reset editId
          await this.fetchCapaData();
        } else {
          toast.error(
            "Erro ao atualizar a capa. Verifique os dados e tente novamente.",
          );
        }
      } else {
        // Create
        const url = `${this.baseURL}/api/v1/capa/`;
        const result = await this.create(dataToSave, url);
        if (result) {
          // Upload file if one was selected
          if (file) {
            await this.uploadFile(file, result.id);
          }
          
          toast("Capa criada com sucesso!", {
            type: "success",
          });
          this.showCapaForm = false; // Close form after creation
          await this.fetchCapaData();
          
        } else {
          toast.error(
            "Erro ao criar a capa. Verifique os dados e tente novamente.",
          );
        }
      }
    },
    async uploadFile(file, capaId) {
      try {
        const formData = new FormData();
        formData.append("arquivo", file);

        const response = await axios.post(
          `${this.baseURL}/api/v1/capa/foto/${capaId}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          this.$refs.capaFormRef.setUploadMessage(
            "Arquivo enviado com sucesso!",
            "text-green-400"
          );
        //   this.$refs.capaFormRef.clearFileInput();
          toast("Arquivo enviado com sucesso!", { type: "success" });
          this.$refs.dataTableRef.refresh();
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Erro ao enviar arquivo";
        this.$refs.capaFormRef.setUploadMessage(
          errorMessage,
          "text-red-400"
        );
        toast.error(errorMessage);
        console.error("Erro ao enviar arquivo:", error);
      }
    },
    handleCancel() {
      this.showCapaForm = false;
    },
    async viewFile(item) {
         if (!item.capa_path) {
        toast("Nenhum arquivo disponível", { type: "warning" });
        return;
      }
      try {
        const response = await axios.get(`${this.baseURL}/api/v1/capa/foto/${item.id}/`, {
          responseType: 'blob', // Ensure the response is a Blob
        });

        // Create a URL for the Blob
        this.imageUrl = URL.createObjectURL(response.data);
        this.showImageModal = true;
      } catch (error) {
        console.error('Error fetching image:', error);
        this.$emit('error', 'Erro ao carregar a imagem.');
      }
    },
    closeImageModal() {
      this.showImageModal = false;
      this.imageUrl = null;
    },
    handleImageError() {
      this.imageUrl = null;
      this.$emit('error', 'Erro ao carregar a imagem.');
    },
    async handleDelete(item){
        try {
          await axios.delete(`${this.baseURL}/api/v1/capa/${item.id}/`);
          toast("Capa eliminada com sucesso!", { type: "success" });
          this.fetchCapaData();
        } catch (error) {
          console.error("Erro ao eliminar capa:", error);
          toast.error("Erro ao eliminar capa. Tente novamente.");
        }
    }
  },
  created() {
    this.fetchCapaData();
    this.select(this.baseURL + "/api/v1/familia/").then(
      (data) => {
        this.familias = data;
      },
    );
  },
};
</script>
